const MOBILE_PANEL_SCROLL_SELECTOR = ".gis-mobile-drawer__scroll";

export const scrollElementIntoMobilePanel = (element, { delay = 120, offset = 12 } = {}) => {
  if (!element || typeof window === "undefined") {
    return undefined;
  }

  let timeoutId;

  const run = () => {
    const scrollParent = element.closest(MOBILE_PANEL_SCROLL_SELECTOR);

    if (!scrollParent) {
      element.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
      return;
    }

    const parentRect = scrollParent.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    const isAbove = elementRect.top < parentRect.top + offset;
    const isBelow = elementRect.bottom > parentRect.bottom - offset;

    if (!isAbove && !isBelow) {
      return;
    }

    const nextTop = scrollParent.scrollTop + (elementRect.top - parentRect.top) - offset;

    scrollParent.scrollTo({
      top: Math.max(0, nextTop),
      behavior: "smooth",
    });
  };

  const frameId = window.requestAnimationFrame(() => {
    timeoutId = window.setTimeout(run, delay);
  });

  return () => {
    window.cancelAnimationFrame(frameId);
    if (timeoutId != null) {
      window.clearTimeout(timeoutId);
    }
  };
};
